export default {
  container: {
    marginBottom: 40,
    borderBottom: 'solid 1px #eee',
    paddingBottom: 30,
  },
};



// WEBPACK FOOTER //
// ./src/components/Header/styles.js